import { createApi } from '@reduxjs/toolkit/query/react';
import { transformErrorResponse, transformSucessResponse } from '../../utils/API/responseMiddleware';
import { defautBaseQuery } from '../../utils/API/fetchBaseQuery';
import { encryptQueryString, transformRequest } from '../../utils/API/requestMiddleware';

const dashboardAPI = createApi({
    baseQuery: defautBaseQuery, 
    reducerPath: 'dashboardAPI',
    endpoints: (builder) => ({
        getChemIndexDashboardCountsDetils: builder.query({
            query: () => ({
                url: '/Dashboard/GetChemIndexDashboardCountsDetils',
                method: 'GET',
            }),
            transformResponse: transformSucessResponse,
            transformErrorResponse: transformErrorResponse
        }),

        getChemProductsMonthlyGrowth: builder.query({
            query: (year) => ({
                url: encryptQueryString(`/Dashboard/GetChemProductsMonthlyGrowth?year=${year}`),
                method: 'GET',
            }),
            transformResponse: transformSucessResponse,
            transformErrorResponse: transformErrorResponse
        }),

        getChemProductsAvailableYears: builder.query({
            query: () => ({
                url: '/Dashboard/GetChemProductsAvailableYears',
                method: 'GET',
            }),
            transformResponse: transformSucessResponse,
            transformErrorResponse: transformErrorResponse
        }),
    })
});

export const {
    useGetChemIndexDashboardCountsDetilsQuery,
    useGetChemProductsMonthlyGrowthQuery,
    useGetChemProductsAvailableYearsQuery
} = dashboardAPI;

export default dashboardAPI;